import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getUserConfig, saveUserConfig } from '@/services/userConfigService';
import type { UserConfigurationState } from '@/types/userConfiguration';
import Logger from '@/utils/logger';

export const useUserConfigQuery = (userId?: string) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['userConfig', userId],
    queryFn: async () => {
      const result = await getUserConfig(userId!);
      return result;
    },
    enabled: !!userId,
  });

  const mutation = useMutation({
    mutationFn: async (payload: UserConfigurationState) => {
      await saveUserConfig(userId!, payload);
      return payload;
    },
    onError: (error) => {
      Logger.error('saveUserConfig mutation failed', error as Error, { 
        component: 'useUserConfigQuery', 
        userId 
      });
    }
  });

  return { ...query, saveConfig: mutation.mutateAsync, isSaving: mutation.isPending };
};
